import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';

export const StyledSection = styled(Box)`
  padding: ${themeSpace(10)} ${themeSpace(4)} 0;
`;

export const StyledFlex = styled(Flex)`
  width: 100%;
  max-width: 390px;
  ${themeMediaQuery('sm')} {
    max-width: 520px;
  }
`;

export const StyledTextPairing = styled(TextPairing)``;
